import * as tslib_1 from "tslib";
import { ToastrService } from 'ngx-toastr';
import { OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from '../../../../core/decorators/auto-unsubscribe';
import { AuthService } from '../../../../core/services/auth.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { EmailService } from '../../../modulos/general/componentes/gestion-terceros/servicios/email.service';
import { GestionEmailService } from '../../../modulos/panel-control/componentes/gestion-email/gestion-email.service';
let ModalMailComponent = class ModalMailComponent {
    constructor(_emailService, translateService, toastr, _globals, _authService, _gestionEmailService) {
        this._emailService = _emailService;
        this.translateService = translateService;
        this.toastr = toastr;
        this._globals = _globals;
        this._authService = _authService;
        this._gestionEmailService = _gestionEmailService;
        this.childModalClose = new EventEmitter();
        this.contadorCaracteres = 0;
        this.placeholderDescription = '';
        this.placeholderAsunto = '';
        this.placeholdermailPara = '';
    }
    blurElement(name) {
        if (this.formMail.get(name).value === '' || this.formMail.get(name).value === null) {
            switch (name) {
                case 'mailPara':
                    this.placeholdermailPara = this.textObligado;
                    break;
                case 'Asunto':
                    this.placeholderAsunto = this.textObligado;
                    break;
                case 'Description':
                    this.placeholderDescription = this.textObligado;
                    break;
            }
        }
        else {
            this.placeholderDescription = '';
            this.placeholderAsunto = '';
            this.placeholdermailPara = '';
        }
    }
    ngOnInit() {
        this.userProfile = this._authService.getUserProfile();
        this.customerId = this._authService.getCustomerId();
        if (this.userProfile.SmtpConfiguration) {
            this.EmailFrom = this.userProfile.SmtpConfiguration.EmailFrom;
        }
        else {
            this.EmailFrom = '';
        }
        this.translateService.get('errors.required.campoObligatorio').subscribe(text => {
            this.textObligado = text;
        });
        this.clientCode = this._authService.getCustomerCode();
        this.companyCode = this._authService.getCompanyCode();
        this.fechaActual = this._globals.getDateFormatForServerNow();
        this.crearForm();
        this.getEmailData();
    }
    getEmailData() {
        this._gestionEmailService.getComboTypeEmail().subscribe(resp => {
            this.emailDataList = resp.Response;
            this.fillMailData();
        });
    }
    fillMailData() {
        this.emailDataList.filter((emailData) => {
            if (emailData.TemplateCode === this.emailMessageData.code) {
                emailData.Text = this.transformEmailMessage(emailData);
                this.formMail.get('Asunto').setValue(emailData.TemplateDescription);
                this.formMail.get('Description').setValue(emailData.Text);
            }
        });
    }
    transformEmailMessage(emailData) {
        emailData.MessageTemplateFieldsList.forEach(field => {
            let replaceText;
            switch (field.FieldCode) {
                case '@@EMLORCustomerName':
                    replaceText = this.emailMessageData.customerName;
                    break;
                case '@@EMLORPlate':
                    replaceText = this.emailMessageData.plate;
                    break;
                case '@@EMLORPreviewedDate':
                    replaceText = this._globals.getDateFormatMDY(this.emailMessageData.previewedDeliveryDate);
                    break;
                case '@@EMLORTotalAmount':
                    replaceText = this.emailMessageData.totalProductionOrderAmount.toFixed(2) + '€';
                    break;
                case '@@EMLORVin':
                    replaceText = this.emailMessageData.vin;
                    break;
                case '@@EMLORTotalWithIVA':
                    replaceText = this.emailMessageData.totalVat.toFixed(2) + '€';
                    break;
                default:
                    replaceText = field.FieldCode;
                    break;
            }
            emailData.Text = emailData.Text.replace(field.FieldCode, replaceText);
        });
        return emailData.Text;
    }
    crearForm() {
        this.formMail = new FormGroup({
            mailDe: new FormControl(this.EmailFrom, [Validators.required]),
            mailPara: new FormControl(this.emailMessageData && this.emailMessageData.emailTo ? this.emailMessageData.emailTo : '', [Validators.required]),
            Asunto: new FormControl('', [Validators.required]),
            Description: new FormControl('', [Validators.required])
        });
        this.subs2 = this.formMail.get('Description').valueChanges.subscribe(val => {
            if (val !== '') {
                this.contadorCaracteres = val.length;
            }
        });
    }
    getValueControl(name) {
        return this.formMail.get(name).value === '' || this.formMail.get(name).value === null;
    }
    valueChange(value) {
    }
    // modalMail
    closeModal(conDatos) {
        if (conDatos) {
            if (this.comprobarCampos()) {
                const datosFormulario = this.formMail.getRawValue();
                const EmailDetailList = [];
                const SMSSendDetailObject = {
                    CustomerCode: this.CustomerCodePhone,
                    Email: datosFormulario.mailPara,
                    Subject: datosFormulario.Asunto,
                    Text: datosFormulario.Description
                };
                EmailDetailList.push(SMSSendDetailObject);
                const b = {
                    CLIENTCODE: this.customerId,
                    COMPANYCODE: this.companyCode,
                    SMTServerID: 2,
                    TemplateCode: 'DEFAULT',
                    SendDate: this.fechaActual,
                    EmailDetailList: EmailDetailList
                };
                this.saveSubscription = this._emailService.post(JSON.stringify(b)).subscribe(data => {
                    const auxdata = data.Response;
                    if (auxdata.Data) {
                        this.translateService.get('conceptFlow.add').subscribe(text => {
                            this.toastr.success(text);
                            this.childModalClose.emit('cerrar');
                        });
                    }
                    else {
                        this.error = data.Warning.Content;
                        this.msg = data.Warning.Title;
                        this.throwAlertError(this.msg, this.error); // alert  Este es el que salepor la derecha con fondo rojo
                        this.childModalClose.emit('cerrar');
                    }
                }, error => {
                    this.error = error.error.ErrorMessage;
                    this.code = error.error.ErrorCode;
                    this.childModalClose.emit('cerrar');
                });
            }
        }
        else {
            this.childModalClose.emit('cerrar');
        }
    }
    throwAlertError(text1, text2) {
        this.toastr.error(text1, text2, {
            closeButton: true
        });
    }
    comprobarCampos() {
        const datosForm = this.formMail.getRawValue();
        if (datosForm.mailDe !== null && datosForm.mailDe !== '' && datosForm.mailPara !== null && datosForm.mailPara !== ''
            && datosForm.Asunto !== null && datosForm.Asunto !== '' && datosForm.Description !== null && datosForm.Description !== '') {
            return true;
        }
        else {
            return false;
        }
    }
};
ModalMailComponent = tslib_1.__decorate([
    AutoUnsubscribe(),
    tslib_1.__metadata("design:paramtypes", [EmailService,
        TranslateService,
        ToastrService,
        GlobalsService,
        AuthService,
        GestionEmailService])
], ModalMailComponent);
export { ModalMailComponent };
